import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { from } from 'rxjs';
import { MultipleSelectItemComponent } from './multiple-select-item/multiple-select-item.component';
import { ItemEntryComponent } from './item-entry/item-entry.component';
import { TransactionComponent } from './transaction/transaction.component';
import { StoreTransferComponent } from './store-transfer/store-transfer.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { StockComponent } from './stock/stock.component'
import { StageSelectionComponent } from './stage-selection/stage-selection.component';
import { ProductUnitsComponent } from './product-units/product-units.component';
import { UnitsComponent } from './units/units.component';
import { CategoriesComponent } from './categories/categories.component';
import { SubCategoriesComponent } from './sub-categories/sub-categories.component';
import { ValuationComponent } from './valuation/valuation.component'
import { ProductBOMComponent } from './product-bom/product-bom.component';
import { TransactionJobsComponent } from './transaction-jobs/transaction-jobs.component';
import { ProductByproductsComponent } from './product-byproducts/product-byproducts.component';
import { SettingsComponent } from './settings/settings.component';
import { StoresComponent } from './stores/stores.component'
import { ReportComponent } from './report/report.component'
import { StockExpandComponent } from './stock-expand/stock-expand.component';
import { HSNListComponent } from './hsn-list/hsn-list.component';
import { TagsComponent } from './tags/tags.component';
import { ImportItemsComponent } from './import-items/import-items.component';
import { HSNSACComponent } from './hsn-sac/hsn-sac.component';
import { AuthGuardService } from '../services/auth-guard.service';
import { MultiUnitCalculatorComponent } from './multi-unit-calculator/multi-unit-calculator.component';
import { ImportledgerComponent } from './importledger/importledger.component';
import { TransactionProductionComponent} from './transaction-production/transaction-production.component';
import { BatchSelectionComponent } from './batch-selection/batch-selection.component';
import { ItemSummaryComponent } from './item-summary/item-summary.component';
import { GspcReconcileComponent } from './gspc-reconcile/gspc-reconcile.component';
import { ImportBOMComponent } from './import-bom/import-bom.component';

const routes: Routes = [
    { path: 'ItemSelection', component: MultipleSelectItemComponent, canActivate:[AuthGuardService] },
    { path: 'ProductDetail', component: ProductDetailComponent, canActivate:[AuthGuardService] },
    { path: 'ItemSelection', component: MultipleSelectItemComponent, canActivate:[AuthGuardService] },
    { path: 'Stock', component: StockComponent, canActivate:[AuthGuardService] },
    { path: 'Stages', component: StageSelectionComponent, canActivate:[AuthGuardService] },
    { path: 'transfer', component: StoreTransferComponent, canActivate:[AuthGuardService] },
    { path: 'ProductUnit', component: ProductUnitsComponent, canActivate:[AuthGuardService] },
    { path: 'Stores', component: StoresComponent, canActivate:[AuthGuardService] },
    { path: 'Units', component: UnitsComponent, canActivate:[AuthGuardService] },
    { path: 'Categories', component: CategoriesComponent, canActivate:[AuthGuardService] },
    { path: 'Valuation', component: ValuationComponent },
    { path: 'SubCategories', component: SubCategoriesComponent },
    { path: 'ProductUnit', component: ProductUnitsComponent },
    { path: 'transaction', component: TransactionComponent },
    { path: 'ProductBOM', component: ProductBOMComponent },
    { path: 'transactionJobs', component: TransactionJobsComponent },
    { path: 'ProductByproduct', component: ProductByproductsComponent },
    { path: 'Settings', component: SettingsComponent },
    { path: 'InvReport', component: ReportComponent },
    { path: 'StockExpand', component: StockExpandComponent },
    { path: 'HsnList', component: HSNListComponent },
    { path: 'TagList', component: TagsComponent },
    { path: 'importItems', component: ImportItemsComponent },
    { path: 'HSNSAC', component: HSNSACComponent },
    { path: 'itemEntry', component: ItemEntryComponent },
    { path: 'multiUnitCalculator', component: MultiUnitCalculatorComponent },
    { path: 'importLadger', component: ImportledgerComponent },
    { path: 'XnProduction', component: TransactionProductionComponent},
    { path: 'BatchSelection', component: BatchSelectionComponent},
    { path: 'ItemSummary', component: ItemSummaryComponent},
    { path: 'GSPCRecoEntry', component: GspcReconcileComponent},
    { path: 'ImportBOM', component: ImportBOMComponent}

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class InventoryRoutingModule { }